import { Outlet } from 'react-router-dom';
import {
  ChakraProvider,
  Container,
} from '@chakra-ui/react';
import theme from './theme';
import Footer from './components/Footer';
import Banner from './components/Banner';

const App = () => (
  <ChakraProvider theme={theme}>
    <Banner />
    <Container justifyContent="center" display="flex">
      <Outlet />
    </Container>
    <Footer />
  </ChakraProvider>
);

export default App;
